interface QuestionSubtitleLayoutProps {
  text: string;
}

export const QuestionSubtitleLayout = ({
  text,
}: QuestionSubtitleLayoutProps) => (
  <p className="text-base leading-5">{text}</p>
);
